module.exports = __webpack_public_path__ + "img/左对齐2.c0ee5eb4.svg";